"use client";
import { EyeIcon as e, EyeOffIcon as t } from "../../icons.js";
import { Input as n } from "../Input/Input.js";
import { jsx as r } from "react/jsx-runtime";
import { useState as i } from "react";
//#region src/components/PasswordInput/PasswordInput.tsx
function a({ toggleLabels: a = {
	show: "Show password",
	hide: "Hide password"
}, ...o }) {
	let [s, c] = i(!0);
	return /* @__PURE__ */ r(n, {
		...o,
		type: s ? "password" : "text",
		rightContent: /* @__PURE__ */ r("button", {
			type: "button",
			"aria-label": s ? a.show : a.hide,
			"aria-pressed": !s,
			className: "focus-visible:ring-ic-web-primary/50 hover:text-ic-web-heading block cursor-pointer rounded-md p-1 focus-visible:ring-2 focus-visible:outline-none",
			onClick: () => c((e) => !e),
			children: r(s ? e : t, { className: "size-5" })
		})
	});
}
//#endregion
export { a as PasswordInput };
